import React, { Component } from 'react';
import './App.css';
import './scss/style.default.scss'
import { BrowserRouter, Link} from 'react-router-dom';
import { withRouter } from 'react-router-dom'
import Routes from './Routes';
import './fonts/stylesheet.css'
import './scss/style.default.scss'
import {ReactNotifications} from 'react-notifications-component'


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render(){
    
    return(
      <BrowserRouter>
      <ReactNotifications />
        <Routes />
      </BrowserRouter>
      // <div className="App">
      //      <CustomerLogin/>
      // </div>
    );
  }
}

export default App;
